import {
	Component,
	Input,
	OnInit,
	AfterViewInit,
	ViewChild,
	ViewChildren,
	QueryList,
	ElementRef,
	Renderer2,
	OnDestroy
} from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { AuthService } from '../../../services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { OverlayService } from '../../../services/overlay.service';

declare const Prism;

@Component({
	selector: 'app-rule-engine',
	templateUrl: './rule-engine.component.html',
	styleUrls: ['./rule-engine.component.scss']
})
export class RuleEngineComponent implements OnInit, AfterViewInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('ruleEngineForm', { static: true }) ruleEngineForm: NgForm;
	@ViewChild('snippet', { static: true }) snippet: ElementRef;
	@ViewChild('nameField', { static: true }) nameField;
	@ViewChildren('ruleReference') ruleReference: QueryList<ElementRef>;
	ruleEngineFormSubscription: Subscription;

	snippetHtml: string;
	isConfigShown: Boolean = Boolean(false);
	modalHeight = window.innerHeight * 0.9;
	innerHeight = window.innerHeight * 0.8;
	designedSnippet;
	stringifyConfig;
	howtoURL;
	showRule = 0;
	isHowtoShown = false;
	isAdmin;

	constructor(
		private component: ComponentService,
		private auth: AuthService,
		private overlay: OverlayService,
		private sanitation: DomSanitizer,
		private renderer: Renderer2
	) {}

	ngOnInit() {
		this.ruleEngineFormSubscription = this.ruleEngineForm.valueChanges
			.pipe(
				tap(() =>
					this.component.updateDisabledSave(
						(this.ruleEngineForm.dirty && this.ruleEngineForm.invalid) || this.nameField.editComponentName
					)
				),
				filter((form) => this.ruleEngineForm.dirty && this.ruleEngineForm.valid),
				debounceTime(2000)
			)
			.subscribe();

		this.isAdmin = this.auth.isAdmin();
	}

	// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
	ngAfterViewInit() {
		//  console.log(this.ruleReference.toArray());
		//    console.log(this.ruleReference.toArray()[0].nativeElement.children[2].children[1].children[0].children[1].children[0].children[0].children[0].clientWidth);
		//    console.log(this.ruleReference.toArray()[0].nativeElement.children[2].children[1].children[0].children[1].children[0].children[0].children[0].nodeName);
		//    console.log(this.ruleReference.toArray()[0].nativeElement.children[2].children[1].children[0].children[1].children[0].children[0].children[0].currentSrc);
		// var widthTest;
		//    var imgaeTest = this.ruleReference.toArray()[0].nativeElement.children[2].children[1].children[0].children[1].children[0].children[0].children[0];
		//    imgaeTest.onload = () => {widthTest = imgaeTest.width};
		//    console.log(widthTest);
		//    console.log(this.componentData.config.rules[0].image_url);
	}

	ngOnDestroy() {
		this.ruleEngineFormSubscription.unsubscribe();
	}

	showConfig() {
		this.designedSnippet =
			this.componentData && this.componentData.config
				? Prism.highlight(JSON.stringify(this.componentData.config, null, '\t'), Prism.languages.json)
				: Prism.highlight(JSON.stringify({}, null, '\t'), Prism.languages.json);

		this.stringifyConfig =
			this.componentData && this.componentData.config
				? JSON.stringify(this.componentData.config, null, '\t')
				: JSON.stringify({}, null, '\t');
	}

	editConfig() {
		this.componentData.config = JSON.parse(this.stringifyConfig);
		this.component.updateComponentData(this.componentData);
		this.component.updatePreviewData();
		this.designedSnippet = Prism.highlight(JSON.stringify(this.componentData.config, null, '\t'), Prism.languages.json);
		this.stringifyConfig = JSON.stringify(this.componentData.config, null, '\t');
	}

	addRule() {
		if (this.componentData.config.rules.length < 101) {
			this.collapseOtherRules(this.componentData.config.rules.length);
			this.showRule = this.componentData.config.rules.length;
			this.componentData.config.rules.push({
				image_url: '',
				link: '',
				data: [
					{
						condition: '',
						value: '',
						type: '',
						qualifier: '',
						operator: ''
					}
				]
			});
		} else {
			this.overlay.updateOverlay(true, 'You have reached the maximum rule limit of 100 rules', 'alert');
		}
	}

	duplicateRule(index) {
		if (this.componentData.config.rules.length < 101) {
			this.showRule = index + 1;
			this.collapseOtherRules(index);
			const duplicateRule = this.componentData.config.rules[index];
			this.componentData.config.rules.splice(index, 0, duplicateRule);
		} else {
			this.overlay.updateOverlay(true, 'You have reached the maximum rule limit of 100 rules', 'alert');
		}
	}

	removeRule(index) {
		this.componentData.config.rules.splice(index, 1);
	}

	addCondition(index) {
		//    if (this.componentData.config.rules.length < 101) {
		this.componentData.config.rules[index].data.push({
			condition: '',
			value: '',
			type: '',
			qualifier: '',
			operator: 'and'
		});
		//   } else {
		//     this.overlay.updateOverlay(true, 'You have reached the maximum rule limit of 100 rules', 'alert');
		//   }
	}

	collapseOtherRules(index) {
		for (var i in this.ruleReference.toArray()) {
			if (i != index) {
				if (this.ruleReference.toArray()[i].nativeElement.children[2].children[1].classList.contains('show')) {
					this.renderer.addClass(this.ruleReference.toArray()[i].nativeElement.children[2].children[0], 'collapsed');
					this.renderer.removeClass(this.ruleReference.toArray()[i].nativeElement.children[2].children[1], 'show');
				}
			}
		}
	}

	dateChange(index) {
		console.log('The Date has changed on ' + index);
	}

	onAddressChange(event, index, dataIndex) {
		this.componentData.config.rules[index].data[dataIndex].value = event.address;
	}
}
